import { TableRow, TableCell } from 'src/shared/components/ui/table'

export const QuoteItemRowSpacer = ({
  colSpan,
}: {
  colSpan: number
}) => (
  <TableRow className="border-0 hover:bg-transparent pointer-events-none">
    <TableCell
      colSpan={colSpan}
      className="h-4 p-0 border-0 bg-transparent shadow-none"
    />
  </TableRow>
)
